import React, { useEffect, useState } from 'react';
import { StoryblokComponent } from 'storyblok-js-client';
import { StoryItem, StoryTeaserService } from '../../services';
import { blokToComponent, filterProps } from '../helpers';
import { parseAssetSource } from '../props/asset';
import { Props } from '../types';

export const RocheStoryStagingHero = ({
  blok, slot, getComponent, updateHoistedState, storyId,
}: Props): JSX.Element => {
  const [teaser, setTeaser] = useState<StoryItem>({} as StoryItem);

  useEffect(() => {
    if (!storyId) {
      return;
    }

    StoryTeaserService.getStoryTeaser(storyId as number)
      .then((result) => {
        setTeaser(result);
        // eslint-disable-next-line no-underscore-dangle
        return updateHoistedState?.(1, 1, blok._uid, result);
      });
  }, []);

  const teaserImage = blok?.slotted_story_image?.[0];
  const { slotted } = filterProps(blok);
  const children = Object.keys(slotted)
    .reduce((acc, key) => {
      const slottedComponents = (slotted[key] as StoryblokComponent<string>[])
        .map((component) => ({
          ...component, ratio: '2.39:1', bleed: true, slot: key,
        }));

      return [...acc, ...slottedComponents];
    }, []);

  return (
    <roche-story-staging-hero
      layout={blok?.layout}
      story-type={teaser?.content?.teaser_type}
      story-description={blok?.story_description}
      show-tags={blok?.show_tags}
      story-image={parseAssetSource(teaserImage?.src.filename) || teaserImage?.brightcove_id}
      story-tags={teaser?.content?.tag}
      slot={slot}
    >
      <h1 slot="headline">{blok?.story_headline}</h1>
      {children.map((child, index) => blokToComponent({ blok: child, getComponent }, `${index}`))}
    </roche-story-staging-hero>
  );
};
